export default __webpack_public_path__ + "images/fe8a565d92df17db291ddd964c25ba46-senior_citizen_small.webp";